import { useState, useEffect } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { supabase } from './lib/supabase';
import AuthScreen from './components/AuthScreen';
import Dashboard from './components/Dashboard';

function App() {
  const [session, setSession] = useState(undefined); // undefined = loading

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
    });

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
    });

    return () => subscription.unsubscribe();
  }, []);

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    setSession(null);
  };

  if (session === undefined) return null;

  const protectedElement = session
    ? <Dashboard session={session} user={session.user} onSignOut={handleSignOut} />
    : <AuthScreen onAuth={setSession} />;

  return (
    <Routes>
      <Route
        path="/"
        element={session ? <Navigate to="/friends" replace /> : <AuthScreen onAuth={setSession} />}
      />
      <Route path="/friends" element={protectedElement} />
      <Route path="/friends/:friendId" element={protectedElement} />
      <Route path="/channel/:chatId" element={protectedElement} />
      <Route path="/channel/:chatId/:childId" element={protectedElement} />
      <Route path="/invites" element={protectedElement} />
      <Route path="/p2p" element={protectedElement} />
      <Route path="*" element={protectedElement} />
    </Routes>
  );
}

export default App;
